var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-10 col-sm-11 col-md-11 col-lg-11 col-xl-11" },
        [
          _c("app-input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate",
                value: "required|max:255",
                expression: "'required|max:255'"
              }
            ],
            attrs: {
              id: "addon-name",
              label: "Add-on Name",
              type: "text",
              placeholder: "e.g. T-Shirt or Material Fee",
              name: _vm.addOnInputName
            },
            model: {
              value: _vm.addOnName,
              callback: function($$v) {
                _vm.addOnName = $$v
              },
              expression: "addOnName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "col-2 col-sm-1 col-md-1 col-lg-1 col-xl-1 pb-3 d-flex align-items-center cursor-pointer",
          on: {
            click: function($event) {
              return _vm.$emit("remove")
            }
          }
        },
        [
          _c("img", {
            attrs: { src: require("../../../../assets/img/delete-red.svg") }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-10 col-sm-4 col-md-5 col-lg-5 col-xl-6" }, [
        _c(
          "div",
          { staticClass: "form-group position-relative" },
          [
            _c("label", [_vm._v("Cost")]),
            _vm._v(" "),
            _c(
              "money",
              _vm._b(
                {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: { required: _vm.required, "bigger-or-equal": 0 },
                      expression: "{required, 'bigger-or-equal': 0}"
                    }
                  ],
                  key: _vm.addOn.id,
                  attrs: {
                    label: "Cost",
                    type: "text",
                    placeholder: "$0.00",
                    maxlength: "15",
                    name: _vm.addOnInputPriceName
                  },
                  model: {
                    value: _vm.addOnPrice,
                    callback: function($$v) {
                      _vm.addOnPrice = $$v
                    },
                    expression: "addOnPrice"
                  }
                },
                "money",
                _vm.money,
                false
              )
            ),
            _vm._v(" "),
            _c("div", { staticClass: "error" }, [
              _vm._v(_vm._s(_vm.errors.first(_vm.addOnInputPriceName)))
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-2 col-sm-1 col-md-1 col-lg-1 col-xl-1" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-7 col-sm-4 col-md-3 col-lg-3 col-xl-3" },
        [
          _c("number-peel", {
            staticClass: "mr-4",
            attrs: { label: "Max", name: _vm.addOnMaxName },
            model: {
              value: _vm.addOnMaxAmount,
              callback: function($$v) {
                _vm.addOnMaxAmount = $$v
              },
              expression: "addOnMaxAmount"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-5 col-sm-3 col-md-3 col-lg-3 col-xl-2" }, [
        _c(
          "div",
          { staticClass: "mt-4 p-2 flex-column" },
          [
            _c(
              "checkbox",
              {
                attrs: { checked: _vm.addOnRequired },
                on: {
                  "update:checked": function($event) {
                    _vm.addOnRequired = $event
                  }
                }
              },
              [
                _vm._v(
                  "\n                        Required\n                    "
                )
              ]
            )
          ],
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ed450420", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ed450420","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/main/pages/camp-form/AddOn.vue
// module id = null
// module chunks = 